import { TextInput } from '@cp/ds/src/components/form/components/field/text';
import { withChangeableValue } from '@cp/ds/src/components/form';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { SxProps } from '@cp/ds';
import { Box } from '@cp/ds/src/components/box';
import { SearchIcon } from '@cp/ds/src/icons';
import { debounceTime, filter, of, tap } from 'rxjs';
import { ProcessingAndReviewsFiltersType } from '../processingAndReviews';

const PhoneOrEmailField = withChangeableValue(TextInput);

export const PhoneOrEmail = ({ sx }: { sx: SxProps }) => {
  const form = useFormContext<ProcessingAndReviewsFiltersType>();
  const [value, setValue] = useState(form.getValues('phoneOrEmail'));

  const handleChangePhoneOrEmail = (val?: string) =>
    of(val)
      .pipe(
        tap((str) => setValue(str)),
        tap((str) => str && str.length < 2 && form.setValue('phoneOrEmail', '')),
        filter((str) => !!str && str.length > 2),
        debounceTime(300),
      )
      .subscribe((str) => form.setValue('phoneOrEmail', str));

  return (
    <Box sx={{ position: 'relative' }}>
      <PhoneOrEmailField onChange={handleChangePhoneOrEmail} placeholder="Телефон/почта" sx={sx} value={value} />
      <SearchIcon sx={{ position: 'absolute', top: '50%', right: '16px', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
    </Box>
  );
};
